export default __webpack_public_path__ + "static/media/Armbands of the Eternal Blaze.8ebdc5e2.jpg";